import { useState, useEffect, useCallback, useRef } from "react"

import Grid from '@material-ui/core/Grid'

import Dialog from "@base/Dialog";

import Toast from '@base/Toast'
import SelectOption from '@base/Inputs/Select/Select'
import ColaboradorService from "@services/ColaboradorService"
import AtividadeService from "@services/AtividadeService"
import { Card, CardContent } from "@material-ui/core";
import Chip from '@material-ui/core/Chip';
import ButtonPrimary from '@base/Button'
import AddIcon from '@material-ui/icons/AddOutlined'
import CircularProgress from '@material-ui/core/CircularProgress'

import useAtividades from '@hooks/enums/useAtividades';

export const AtribuirAtividadeDialog = (props) => {
	const toastRef = useRef(null);

	const [processoSelecionado, setProcessoSelecionado] = useState("");
	const [atividadeSelecionada, setAtividadeSelecionada] = useState("");
	const [loading, setLoading] = useState(true);

	const [listagemProcessos, setListagemProcessos] = useState([]);

	const listagemTodasAtividades = useAtividades();
	const [listagemAtividadesDoColaborador, setListagemAtividadesDoColaborador] = useState([]);

	const listagemAtividades = listagemTodasAtividades.data.filter(obj => !listagemAtividadesDoColaborador.find(rm => rm.id === obj.value));

	const removerAtividade = (atividade) => {
		let obj = {
			colaborador : props.id,
			processo : processoSelecionado,
			atividade : atividade,
			adicionar: false
		};

		if (processoSelecionado === "") {
			toastRef.current.show("warning", "É necessário selecionar um Processo para o Colaborador.");
		} else if (atividade === "") {
				toastRef.current.show("warning", "É necessário selecionar uma Atividade para o Colaborador.");
		} else {
			AtividadeService.atualizarAtividadeColaborador(obj).then(caixa => {
				setAtividadeSelecionada("");
				carregarDados();
				toastRef.current.show("success","Atividade de Colaborador em Processo foi removida com sucesso!");
			}).catch(error => toastRef.current.show("error", "Ocorreu um Problema ao remover Atividade de Colaborador em Processo:" + error.response.data.mensagens.map(mensagem => mensagem).join(" ,")));
		}
	}

	const adicionarAtividade = (atividade) => {
		let obj = {
			colaborador : props.id,
			processo : processoSelecionado,
			atividade : atividade,
			adicionar: true
		};

		if (processoSelecionado === "") {
			toastRef.current.show("warning", "É necessário selecionar um Processo para o Colaborador.");
		} else if (atividade === "") {
				toastRef.current.show("warning", "É necessário selecionar uma Atividade para o Colaborador.");
		} else {
			AtividadeService.atualizarAtividadeColaborador(obj).then(caixa => {
				setAtividadeSelecionada("");
				carregarDados();
				toastRef.current.show("success","Atividade de Colaborador em Processo foi adicionada com sucesso!");
			}).catch(error => toastRef.current.show("error", "Ocorreu um Problema ao adicionar Atividade de Colaborador em Processo:" + error.response.data.mensagens.map(mensagem => mensagem).join(" ,")));
		}
	}

	const limparFormulario = () => {
		setProcessoSelecionado("");
		setAtividadeSelecionada("");
		setListagemAtividadesDoColaborador([]);
	}

	const fecharDialog = () => {
		limparFormulario();
		props.aoFechar();
	}

	const carregarDados = useCallback(() => {
		setLoading(true);
		if ((props.id) && (props.aberto)) {
			ColaboradorService.buscarProcessosPorColaborador(props.id).then( resposta => {
        if (resposta.data.length === 1) {
          setProcessoSelecionado(resposta.data[0].id)
        }else {
          setListagemProcessos(resposta.data.map(processo => {
            return {
              label: processo.nome,
              value: processo.id
            };
          }));
        }
			}).catch(error => {
				toastRef.current.show("error", "Ocorreu um Problema ao recuperar Processos associadas a este Colaborador.");
			});

			if (processoSelecionado) {
				AtividadeService.listarAtividadesPorColaboradorAndProcesso(props.id,processoSelecionado).then( resposta => {
					setListagemAtividadesDoColaborador(resposta.data);
				}).catch(error => {
					toastRef.current.show("error", "Ocorreu um Problema ao recuperar Atividades associadas a este Colaborador.");
				});
			} else {
				setListagemAtividadesDoColaborador([]);
			}
		}
		setLoading(false);
	}, [props.id, props.aberto, processoSelecionado]);
	useEffect(() => carregarDados(), [carregarDados]);

	return (
		<>
			<Toast ref={toastRef} />
			<Dialog
				maxWidth={"sm"}
				fullWidth={true}
				closeDialog={fecharDialog}
				openDialog={props.aberto}
				title="Associar Atividade">

        {processoSelecionado === "" &&
          <Grid container spacing={12}>
            <Grid item sm={9}>
              <SelectOption
                label='Processo'
                value={processoSelecionado}
                name='processoSelecionado'
                onChange={(e) => setProcessoSelecionado(e.target.value)}
                options={listagemProcessos} />
            </Grid>
          </Grid>
        }



				{listagemAtividadesDoColaborador && listagemAtividadesDoColaborador.length > 0 ?
				<Card>
					<CardContent style={{ fontSize: 12, borderBottom: "1px solid #ccc", backgroundColor: "#f5f5f5" }}>Atividades Associadas</CardContent>
					<CardContent>
							{listagemAtividadesDoColaborador.map(elemento =>
										<Grid container spacing={12}>
											<Grid item sm={12}>
												<Chip label={elemento.descricao} onDelete={() => removerAtividade(elemento.id)} />
											</Grid>
										</Grid>
							)}
							</CardContent>
							</Card> : <></>}

				{listagemAtividades && listagemAtividades.length > 0 ?
				<Grid container spacing={12}>

					<Grid item sm={9}>
						<SelectOption
							label='Atividade'
							value={atividadeSelecionada}
							name='atividadeSelecionado'
							onChange={(e) => setAtividadeSelecionada(e.target.value)}
							options={listagemAtividades} />
					</Grid>
					<Grid item sm={3}>
						<ButtonPrimary style={{marginTop:33}}
							onClick={() => adicionarAtividade(atividadeSelecionada)}
							name="Adicionar"
							startIcon={loading ? <CircularProgress size={16} /> : <AddIcon />}
							disabled={loading}
						/>
					</Grid>
				</Grid> : <></>}
			</Dialog>
		</>
	);
}

export default AtribuirAtividadeDialog;
